var exports = {
  "x6": "xa15a2ab7--c0030e--button",
  "iW": "xa15a2ab7--c0030e--main",
  "GW": "xa15a2ab7--c0030e--trend",
  "bE": "xa15a2ab7--c0030e--inc",
};

module.exports = exports;
